import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import Swal from "sweetalert2";

import { CircularProgress } from "@mui/material";
import {
  customerservice,
  loanManagementUrl,
  setupManagementUrl,
} from "../../../config";
import {
  executeAnyMutation,
  fetchJsonDynamic,
  fetchJson,
} from "../../../data/DynamicServiceNew/jsondynamicservice";
import { graphqlQuery } from "../../../data/Axios/DynamicService";
import { selectedGridRowsCountSelector } from "@mui/x-data-grid";

const ExcessAmountRecon = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
  // const customersData = [
  //   { id: '36991073', name: 'Lilian Kilani', email: 'fulusi@gmail.com', phone: '0798706353', branch: 'Kitengela', loanLimit: 3000, createdAt: 'Nov 29, 2021' },
  //   // Add more customer data as needed
  // ];
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCustomer, setFilteredCustomer] = useState(null);
  const [loanProductSelected, setLoanProductSelected] = useState([]);
  const [amount, setAmount] = useState("");
  const [IdorPassport, setIdorPassport] = useState("");
  const [comments, setComments] = useState("");
  const [loanProduct, setLoanProduct] = useState("");
  const [customers, setCustomers] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const resetForm = () => {
    setSearchTerm("");
    setFilteredCustomer(null);
    setAmount("");
    setLoanProductSelected("");
    setIdorPassport("");
    setComments("");
  };

  const handlesearch = async () => {
    setLoadingSearch(true); // Start loading

    try {
      const mutationdata = { mobileNumber: searchTerm };

      // Perform API call to search customer
      const customer = await fetchJson({
        objectName: "customersByColumnValues",
        inputObjectName: "customer",
        params: mutationdata,
        baseUrl: customerservice.uri,
      });

      if (JSON.parse(customer.results) === null) {
        Swal.fire("Customer Not Found", "Customer does not exist", "warning");
      }
      setFilteredCustomer(JSON.parse(customer.results) || null); // Update state with customer data
    } catch (error) {
      console.error("Search error:", error);
      Swal.fire(
        "Search Failed",
        "An error occurred during the search. Please try again later.",
        "error"
      );
    } finally {
      setLoadingSearch(false); // End loading after search is completed
    }
  }; // Short debounce delay for a smoother typing experience

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const params = { companyId: companyId };
      const productResponse = await fetchJsonDynamic(
        "allTransType",
        null,
        null,
        loanManagementUrl.uri
      );
      const allProducts = JSON.parse(productResponse.results) || [];
      // Filter regions based on selected company ID

      setLoanProduct(allProducts);
    };
    fetchData();
  }, []);
  const handleAppraisalSubmit = async () => {
    setLoadingSubmit(true); // Start loading when the form is submitted

    // const {phoneoridnumber}=values;

    try {
      const mutationData = {
        p_transtype: loanProductSelected,
        p_customeridfrom: filteredCustomer[0].Id,
        p_destination: IdorPassport,
        p_amount: parseInt(amount),
      };

      const response = await executeAnyMutation(
        "excessAmountRecon",
        mutationData,
        "excessAmountRecon",
        false,
        loanManagementUrl.uri
      );
      const parsedResults = JSON.parse(response.results);
      if (parsedResults.LoanId !== null) {
        if (parsedResults === 200) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: `${
              loanProductSelected === 1
                ? "Processing Fee reversal Successful"
                : loanProductSelected === 2
                ? "Transfering Amount Successful"
                : loanProductSelected === 3
                ? "Collateral to BBF Successfull"
                : "BBF to Collateral Successful"
            }`,
          });
          // Reset form upon successful submission
          resetForm();
        } else if (parsedResults === -1) {
          Swal.fire({
            icon: "error",
            title: "Sorry!",
            text: `${
              loanProductSelected === 1
                ? "Processing Fee reversal Not Successful"
                : loanProductSelected === 2
                ? "Transfering Amount Not Successful"
                : loanProductSelected === 3
                ? "Collateral to BBF Not Successfull"
                : "BBF to Collateral Not Successful"
            }`,
          });
          // Reset form upon successful submission
          resetForm();
        } else {
          Swal.fire({
            icon: "error",
            title: "Unsuccessfull Operation!",
            text: "Operation Not Success",
          });
        }
      } else if (response.errors) {
        throw new Error(
          response.errors[0].Error || "An internal server error occurred."
        );
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
      resetForm();
    } finally {
      setLoadingSubmit(false); // End loading after the process
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h5">Excess Amount Recon</Typography>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={9}>
          <TextField
            label="Search Customer by customer phone number | ID No. | Passport"
            placeholder="Enter search criteria"
            variant="outlined"
            fullWidth
            margin="normal"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              endAdornment: loadingSearch && (
                <CircularProgress size={24} sx={{ marginRight: 2 }} />
              ),
            }}
          />
        </Grid>
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handlesearch}
            disabled={loadingSearch}
          >
            Search
          </Button>
        </Grid>
      </Grid>

      {filteredCustomer && (
        <>
          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Customer Details
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Customer Name:</strong>{" "}
                    {`${filteredCustomer[0].FirstName} ${filteredCustomer[0].OtherNames}`}
                  </Typography>
                  <Typography>
                    <strong>Email:</strong> {filteredCustomer[0].EmailAddress}
                  </Typography>
                  <Typography>
                    <strong>ID Number:</strong>{" "}
                    {filteredCustomer[0].IDNoOrPassport}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography>
                    <strong>Mobile Number:</strong>{" "}
                    {filteredCustomer[0].MobileNumber}
                  </Typography>
                  <Typography>
                    <strong>Date Created:</strong>{" "}
                    {filteredCustomer[0].DateCreated}
                  </Typography>
                  <Typography>
                    <strong>Current Loan Limit:</strong>{" "}
                    {filteredCustomer[0].LoanLimit || "N/A"}
                  </Typography>
                  <Typography>
                    <strong>Customer Balance:</strong>{" "}
                    {filteredCustomer[0].CustomerBalance}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ mb: 2 }}>
            <CardContent>
              <Typography
                variant="h6"
                sx={{
                  backgroundColor: "#003049",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 1,
                }}
              >
                Recon
              </Typography>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Loan Product</InputLabel>
                    <Select
                      value={loanProductSelected}
                      onChange={(e) => setLoanProductSelected(e.target.value)}
                      defaultValue=""
                    >
                      <MenuItem value="" disabled>
                        Select Loan Product
                      </MenuItem>
                      {loanProduct.map((company) => (
                        <MenuItem key={company.Id} value={company.Id}>
                          {company.TransName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Amount to Disburse"
                    placeholder="Enter Amount"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </Grid>

                {/* Conditional rendering based on loanProductSelected */}
                {loanProductSelected !== 1 && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Enter Receiver's phone number | ID | Passport number"
                        placeholder="PhoneNumber | ID | Passport"
                        value={IdorPassport}
                        onChange={(e) => setIdorPassport(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Comments"
                        placeholder="Comments"
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </CardContent>
          </Card>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleAppraisalSubmit}
            disabled={loadingSubmit} // Disable button when loading
          >
            {loadingSubmit ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit For Appraisal"
            )}
          </Button>
        </>
      )}
    </Box>
  );
};

export default ExcessAmountRecon;
